import SimpleEditor from './SimpleEditor';
import ActionsRenderer from './ActionsRenderer';

export default {
    SimpleEditor,
    ActionsRenderer
}